import React from 'react';
import { Col } from 'react-bootstrap';

const ReusableTopRatting = ({ img }) => {
  return (
    <>
      <Col lg={3} xs={6}>
        <div className="top_ratting_main">
          <div className="top_ratting_img">
            <img src={img} className="w-100" alt="" />
            <div className="top_ratting_img_overlay">
              <div className="icon"><i className="fa fa-heart"></i></div>
              <div className="icon"><i className="fa fa-shopping-bag"></i></div>
              <div className="icon"><i className="fa fa-eye"></i></div>
            </div>
          </div>
          <div className="top_ratting_text pt-4 text-center">
            <h3>Organic Fresh Vegetables</h3>
            <ul className="icson">
              <li><i className="fa fa-star"></i></li>
              <li><i className="fa fa-star"></i></li>
              <li><i className="fa fa-star"></i></li>
              <li><i className="fa fa-star"></i></li>
              <li><i className="fa fa-star"></i></li>
            </ul>
            <p>$8.00-9.00</p>
          </div>
        </div>
      </Col>
    </>
  );
};

export default ReusableTopRatting;
